module.exports = __webpack_public_path__ + "img/50-percent-promotion-banner.26c22db6.png";